import { Box, BoxProps, Center, Heading, Text, VStack } from '@/components/Chakra'
import { ReactNode } from 'react'

type Props = {
  title: string
  description: ReactNode
} & BoxProps

export const EmptyState = (props: Props) => {
  return (
    <Box {...props}>
      <Center>
        <VStack>
          <Heading as="p" fontSize={'2xl'}>
            {props.title}
          </Heading>
          <Text color={'gray.500'} align="center">
            {props.description}
          </Text>
        </VStack>
      </Center>
    </Box>
  )
}
